var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "23px",
    viewBox: "0 0 14 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "by-photos",
    transform: "translate(-88.000000, -852.000000)",
    fill: "#302745",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(88.000000, 852.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,5 C13.5522847,5 14,5.44771525 14,6 L14,22 C14,22.5522847 13.5522847,23 13,23 L1,23 C0.44771525,23 0,22.5522847 0,22 L0,6 C0,5.44771525 0.44771525,5 1,5 L13,5 Z M12,7 L2,7 L2,21 L12,21 L12,7 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,9.5 L4,18.5 C4,19.0522847 4.44771525,19.5 5,19.5 C5.55228475,19.5 6,19.0522847 6,18.5 L6,9.5 C6,8.94771525 5.55228475,8.5 5,8.5 C4.44771525,8.5 4,8.94771525 4,9.5 Z",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,1 L6,3 C6,3.55228475 6.44771525,4 7,4 C7.55228475,4 8,3.55228475 8,3 L8,1 C8,0.44771525 7.55228475,0 7,0 C6.44771525,0 6,0.44771525 6,1 Z",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,4 L13,4 C13.5522847,4 14,3.55228475 14,3 C14,2.44771525 13.5522847,2 13,2 L1,2 C0.44771525,2 0,2.44771525 0,3 C0,3.55228475 0.44771525,4 1,4 Z",
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,9.5 L8,18.5 C8,19.0522847 8.44771525,19.5 9,19.5 C9.55228475,19.5 10,19.0522847 10,18.5 L10,9.5 C10,8.94771525 9.55228475,8.5 9,8.5 C8.44771525,8.5 8,8.94771525 8,9.5 Z",
    id: "Line"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/bin_icon.ad1f5c77.svg";
export { ForwardRef as ReactComponent };